<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "SOLICITAR" : "ACTUALIZAR" }} VIDEOLLAMADA</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

      <div class="p-6">

        <!-- ID CONTACT -->
        <!-- <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input label="ID Video Call Type" v-model="id_video_call_type" class="mt-1 w-full" name="id_video_call_type" disabled/>
            </div>
        </div> -->

        <!-- NAME VIDEOCALLTYPE -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <label class="vs-input--label">Tipo de Videollamada</label>
            <v-select :closeOnSelect="true" v-model="video_call_type_id" label="name_video_call_type" :options="videoCallTypesAdmin" name="video_call_type_id" :reduce="videoCallTypesAdmin => videoCallTypesAdmin.id_video_call_type"></v-select>
          </div>
        </div>

        <!-- <div class="vx-row">
          <div class="vx-col w-full">
            <p></p>
          </div>
        </div> -->

        <!-- CLIENT AVAILABILITY -->
        <div class="vx-row" v-if="this.video_call_type_id">
          <div class="vx-col w-full mt-4">
            <vs-input label="¿Qué disponibilidad posee durante la semana para efectuar la videollamada?" v-model="client_availability" placeholder="Todo el día martes / Jueves a partir de las 3pm" class="mt-1 w-full" name="client_availability" v-validate="'required|max:255'"/>
            <span class="text-danger text-sm" v-show="errors.has('client_availability')">{{ errors.first('client_availability') }}</span>
          </div>
        </div>

        <div class="vx-row" v-if="this.video_call_type_id == '1'">
          <div class="vx-col w-full mt-4">
            <label class="vs-input--label">¿Usted desea hablar sobre algún negocio en especial durante la reunión con el equipo?</label>
            <ul class="centerx">
              <li>
                <vs-radio v-model="choice" vs-value="0">No</vs-radio>
              </li>
              <li>
                <vs-radio v-model="choice" vs-value="1">Si</vs-radio>
              </li>
            </ul>
            <!-- {{ this.choice }} -->
          </div>
        </div>

        <!-- LIST OF BUSINESS -->
        <div class="vx-row" v-if="this.video_call_type_id == '1' && this.choice == 1">
          <div class="vx-col w-full mt-4">
          <vs-input label="Indique el o los ID negocios de interés para la reunión" placeholder="2711 / 2711,2712,2713" v-model="list_of_business" class="mt-1 w-full" name="list_of_business" v-validate="''"/>
          </div>
        </div>

        <!-- LIST OF BUSINESS -->
        <div class="vx-row" v-if="this.video_call_type_id == '2'">
          <div class="vx-col w-full mt-4">
            <vs-input label="Indique ID del negocio de interés" v-model="list_of_business" class="mt-1 w-full" name="list_of_business" v-validate="'numeric'"/>
            <span class="text-danger text-sm" v-show="errors.has('list_of_business')">{{ errors.first('list_of_business') }}</span>
          </div>
        </div>
        
    </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Ingresar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        // let { id_video_call_type, name_video_call_type, description_video_call_type, slug_video_call_type, business_number_video_call_type } = JSON.parse(JSON.stringify(this.data))
        // this.id_video_call_type = id_video_call_type
        // this.name = name_video_call_type
        // this.description = description_video_call_type
        // this.slug = slug_video_call_type
        // this.business_number = business_number_video_call_type
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data () {
    return {
      choice: null,
      video_call_type_id: null,
      client_availability: null,
      list_of_business: null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    videoCallTypesAdmin () {
      return this.$store.state.videoCallTypesAdmin
    },
    isFormValid () {
      if (this.choice === 0) return !this.errors.any() && this.client_availability && this.video_call_type_id
      else return !this.errors.any() && this.client_availability && this.video_call_type_id && this.list_of_business
    }
  },
  methods: {
    initValues () {
      if (this.data.id_video_call_type) return
      this.video_call_type_id = null
      this.client_availability = null
      this.list_of_business = null
      this.choice = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
            
          const obj = {
            video_call_type_id: this.video_call_type_id,
            client_availability: this.client_availability,
            list_of_business: this.list_of_business
          }
          if (this.choice === 0) { delete obj.list_of_business }
          this.$vs.loading()
          this.$store.dispatch('addVideoCall', obj)
            .then(() => { this.$emit('closeSidebar') })
            .then(() => { this.$vs.loading.close() })
            .then(() => {
              this.$vs.notify({
                title: 'Solicitud de videollamada creada',
                text: 'Ha realizado una solicitud de videollamada',
                color: 'success',
                iconPack: 'feather',
                icon:'icon-check'
              }) 
            })
            .then(() => { this.initValues() })
            .catch(err => { 
              this.$vs.loading.close()
              // console.log(Object.getOwnPropertyNames(err))
              // console.log(err.response)
              console.error(err)
              const mensaje_error = err.response.data.error
              this.$vs.notify({
                title: 'Error',
                text:  `${mensaje_error}`,
                color: 'danger',
                iconPack: 'feather',
                icon:'icon-alert-circle',
                time:6000
              })
            })
        }
      })
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}
</style>
